import { useNavigate } from 'react-router-dom';
import { IconHammer, IconArrowRight } from '@tabler/icons-react';
import { PORTAL_NAV_ITEMS } from '../../types/portal';
import { ONBOARDING_SECTIONS } from '../../types/onboarding';
import { findNavItemAndSection } from '../../utils/portalHelpers';

interface PortalPlaceholderProps {
  routeId: string;
}

export function PortalPlaceholder({ routeId }: PortalPlaceholderProps) {
  const navigate = useNavigate();

  const { navItem, editSection } = findNavItemAndSection(routeId, PORTAL_NAV_ITEMS, ONBOARDING_SECTIONS);

  return (
    <div className="py-12 flex flex-col items-center text-center">
      <div className="w-16 h-16 rounded-2xl bg-cyan-900/20 border border-cyan-500/20 flex items-center justify-center mb-6">
        <IconHammer size={32} className="text-cyan-400/60" stroke={1.5} />
      </div>

      <h1 className="text-2xl font-bold text-gray-100 mb-2">{navItem?.title ?? 'Coming Soon'}</h1>
      <p className="text-sm text-gray-500 max-w-md mb-6">
        {navItem?.description || 'This section is under construction and will be available in a future update.'}
      </p>

      <div className="card px-6 py-4 text-sm text-gray-400">
        This page will be built in an upcoming milestone.
      </div>

      {editSection && navItem && (
        <button
          onClick={() => navigate(editSection.path, { state: { from: 'portal', portalPath: navItem.path } })}
          className="flex items-center gap-2 mt-6 text-sm text-cyan-400 hover:text-cyan-300 transition-colors"
        >
          Edit {editSection.title.toLowerCase()} data
          <IconArrowRight size={16} />
        </button>
      )}
    </div>
  );
}
